module.exports = __webpack_public_path__ + "static/media/mainBGLightGreen.5c156469.png";